import { HtmlContentHeuristic } from '../../../interfaces/html-content-heuristic';
import { fontSize } from '../html-content-properties/font-size';

// break when the font size becomes larger, indicating a header
export const breakOnFontSizeIncrease: HtmlContentHeuristic = {
  reason: 'font size increased',
  evaluate: (next: Record<string, any>, prev: Record<string, any>) => next.fontSize > prev.fontSize,
  properties: [fontSize]
};
